"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../../../comps/reusables");
const graphql_1 = require("../../../../../graphql");
const Yup = tslib_1.__importStar(require("yup"));
const ContentConversionListDetail_1 = require("./ContentConversionListDetail");
const react_2 = require("@osmosys/react");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
exports.ContentConversionList = props => {
    const { integration } = props;
    const { history } = use_react_router_1.default();
    const variables = {
        cmsId: integration.id,
    };
    return (react_1.default.createElement(reusables_1.QueryList, { queryProps: {
            fetchPolicy: 'cache-and-network',
            query: graphql_1.contentConversions,
            variables,
        }, queryVariables: variables, item: ContentConversionListDetail_1.ContentConversionListDetail, itemName: "content conversion", itemsKey: "contentConversions", countKey: "contentConversionsCount", itemURL: data => `/integrations/${integration.id}/conversions/${data.id}`, showNewBtn: true, form: (refetch, close, refetchInfo) => (react_1.default.createElement(reusables_1.Form, { mutationProps: {
                awaitRefetchQueries: true,
                mutation: graphql_1.createOrUpdateConversion,
                onCompleted: data => {
                    setTimeout(() => {
                        history.push(data.createOrUpdateConversion.resourceEndpoint);
                    }, 600);
                },
                refetchQueries: [refetchInfo],
            }, valuesToVariables: values => {
                return {
                    cmsId: integration.id,
                    data: {
                        name: values.name,
                    },
                };
            }, formikProps: {
                initialValues: {
                    name: '',
                },
                validationSchema: Yup.object().shape({
                    name: Yup.string().required('Required'),
                }),
            } }, (formikProps, mutationResult) => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(reusables_1.FormGroup, { label: "Content conversion name", name: "name", placeholder: "Blog post conversion" }),
            react_1.default.createElement(reusables_1.AjaxButton, { type: "submit", disabled: formikProps.isSubmitting || !formikProps.dirty, loading: mutationResult.loading, error: mutationResult.error, success: !!mutationResult.data, label: "Add content conversion", onClick: () => {
                    formikProps.handleSubmit();
                } }),
            react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "ContentConversion", action: "create", apolloError: mutationResult.error }))))) }));
};
//# sourceMappingURL=index.js.map